// Mobile Navigation - Simple and Clean like josep.cc
jQuery(document).ready(function($) {
    
    // Mobile menu toggle functionality
    function initMobileMenu() {
        const $hamburger = $('.hamburger, .site-header__menu-btn');
        const $mobileMenu = $('.mobile-menu');
        const $body = $('body');
        
        // Toggle mobile menu
        $hamburger.on('click', function(e) {
            e.preventDefault();
            
            const isOpen = $body.hasClass('nav-open');
            
            if (isOpen) {
                // Close menu
                closeMobileMenu();
            } else {
                // Open menu
                openMobileMenu();
            }
        });
        
        // Close menu when clicking on a link
        $('.mobile-nav__link, .mobile-nav__sublink, .mobile-nav__subsublink').on('click', function() {
            // Only close if it's an actual link (not just href="#")
            const href = $(this).attr('href');
            if (href && href !== '#' && !href.startsWith('#')) {
                setTimeout(() => {
                    closeMobileMenu();
                }, 150);
            }
        });
        
        // Close menu when clicking overlay (outside nav content)
        $mobileMenu.on('click', function(e) {
            if (e.target === this) {
                closeMobileMenu();
            }
        });
        
        // Close menu with ESC key
        $(document).on('keydown', function(e) {
            if (e.key === 'Escape' && $body.hasClass('nav-open')) {
                closeMobileMenu();
            }
        });
        
        // Close menu when window resizes above mobile breakpoint
        $(window).on('resize', function() {
            if ($(window).width() > 768 && $body.hasClass('nav-open')) {
                closeMobileMenu();
            }
        });
        
        function openMobileMenu() {
            $body.addClass('nav-open');
            $hamburger.addClass('is-active');
            $mobileMenu.addClass('is-active');
            $hamburger.attr('aria-expanded', 'true');
            
            // Prevent background scrolling
            $body.css('overflow', 'hidden');
        }
        
        function closeMobileMenu() {
            $body.removeClass('nav-open');
            $hamburger.removeClass('is-active');
            $mobileMenu.removeClass('is-active');
            $hamburger.attr('aria-expanded', 'false');
            
            // Restore background scrolling
            $body.css('overflow', '');
        }
    }
    
    // Initialize mobile menu
    initMobileMenu();
    
    // Handle smooth scrolling for anchor links
    $('.mobile-nav__link[href^="#"], .mobile-nav__sublink[href^="#"], .mobile-nav__subsublink[href^="#"]').on('click', function(e) {
        const href = $(this).attr('href');
        
        if (href.length > 1) { // More than just "#"
            const target = $(href);
            
            if (target.length) {
                e.preventDefault();
                
                // Close mobile menu first
                $('body').removeClass('nav-open');
                $('.hamburger, .site-header__menu-btn').removeClass('is-active');
                $('.mobile-menu').removeClass('is-active');
                $('body').css('overflow', '');
                
                // Then smooth scroll to target
                setTimeout(() => {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 80 // Account for fixed header
                    }, 800);
                }, 300);
            }
        }
    });
    
    // Add active states based on current page
    function updateActiveStates() {
        const currentPath = window.location.pathname;
        
        $('.mobile-nav__link, .mobile-nav__sublink, .mobile-nav__subsublink').each(function() {
            const $link = $(this);
            const linkPath = new URL($link.attr('href'), window.location.origin).pathname;
            
            if (linkPath === currentPath) {
                $link.addClass('is-active');
                $link.closest('.mobile-nav__item, .mobile-nav__subitem').addClass('is-current');
            }
        });
    }
    
    // Update active states on page load
    updateActiveStates();
    
    // Simple fade-in animation for menu items
    function animateMenuItems() {
        $('.mobile-nav__item').each(function(index) {
            $(this).css({
                'opacity': '0',
                'transform': 'translateY(20px)'
            }).delay(index * 50).animate({
                'opacity': '1'
            }, 300).css('transform', 'translateY(0)');
        });
    }
    
    // Trigger animation when menu opens
    $(document).on('click', '.hamburger, .site-header__menu-btn', function() {
        if (!$('body').hasClass('nav-open')) {
            setTimeout(animateMenuItems, 100);
        }
    });
});